import {Component, OnInit, Input, EventEmitter, Output} from '@angular/core';
import {FormGroup, FormBuilder, Validators, AbstractControl, FormControl} from "@angular/forms";
import {AgendaService} from "../shared/model/agenda.service";
import {isoDate} from "../shared/util/date-util";
import {TranslateService} from "@ngx-translate/core";
import {AuthService} from "../shared/security/auth.service";
import {TenantService} from "../shared/model/tenant.service";
import {Court} from "../shared/model/court";
import {AgendaItem} from "../shared/model/agendaItem";

@Component({
  selector: 'app-agenda-add',
  templateUrl: './agenda-add.component.html',
  styleUrls: ['./agenda-add.component.css']
})
export class AgendaAddComponent implements OnInit {
  @Input()
  tenantId: number;

  @Output()
  onAddAgendaDone = new EventEmitter<boolean>();

  day: number = 1;
  index: number;
  court: number;
  startTime: string;   // local time as HH:MM
  endTime: string;   // local time as HH:MM
  name: string;
  duration: number;    // time in seconds
  type: string = 'normal';

  startTimeHours: number = 18;
  startTimeMinutes: number = 0;
  endTimeHours: number = -1;
  endTimeMinutes: number = -1;
  startTimeInMinutes: number = -1;  // 60 * hours + minutes

  clubId: string;
  courts: Court[] = [];
  currentCourt: Court = null;

  public visibleAddAgenda = true;
  public visibleAddAgendaAnimate = false;

  myForm: FormGroup;
  isSaved: boolean = false;
  hasError: boolean = false;
  message: string = "";

  useDuration: boolean = true;
  isOn: boolean = true;

  dayList = ['l.day1', 'l.day2', 'l.day3', 'l.day4', 'l.day5', 'l.day6', 'l.day7'];
  days = [ false, false, false, false, false, false, false, false];

  constructor(private fb: FormBuilder, private agendaService: AgendaService, private translate: TranslateService, private authService: AuthService, private tenantService: TenantService) {
    this.myForm = fb.group({
      'startTimeHours': ['', Validators.compose([Validators.required, Validators.min(0), Validators.max(23), Validators.maxLength(2)])],
      'startTimeMinutes': ['', Validators.compose([Validators.required, Validators.min(0), Validators.max(59), Validators.maxLength(2)])],
      'endTimeHours': ['', Validators.compose([Validators.min(0), Validators.max(23), Validators.maxLength(2)])],
      'endTimeMinutes': ['', Validators.compose([Validators.min(0), Validators.max(59), Validators.maxLength(2)])],
      'duration': ['', Validators.compose([Validators.min(1), Validators.max(1440)])],
      'type': ['', Validators.compose([])],
      'name': ['', Validators.compose([Validators.maxLength(20)])]
    });
  }

  ngOnInit() {
    this.tenantId = this.authService.getTenantIdForUser();
    this.clubId = this.authService.getClubIdForUser();
    //console.log(`tenantId: ${this.tenantId}, clubId: ${this.clubId}`);
    this.tenantService.getCourts(this.tenantId, this.clubId).then( cts => {
      this.courts = cts;
    });

    this.setDuration( true );
    this.calculateStartTime( true );
  }

  public show(): void {
    this.visibleAddAgenda = true;
    setTimeout(() => this.visibleAddAgendaAnimate = true, 300);
  }

  public hide(): void {
    this.visibleAddAgendaAnimate = false;
    setTimeout(() => this.visibleAddAgenda = false, 300);
  }

  public save() {
    if ( !this.useDuration  && !this.endTime ) {
      this.endTime = this.timeToString(this.endTimeHours, this.endTimeMinutes);
    } else if ( this.useDuration ) {
      this.endTime = null;
    }
    const newAgendaItem = new AgendaItem( -1, this.tenantId, -1, this.currentCourt.court, this.startTime, this.name,
      this.duration ? Number(this.duration) : null, this.type, this.endTime ? this.endTime : null);

    if ( !this.isOn ) {
      newAgendaItem.duration = null;
      newAgendaItem.endTime = null;
    }

    for ( let i = 0; i < this.days.length; i++ ) {
      if ( this.days[i] ) {
        newAgendaItem['day'] = i + 1;
        //console.log( newAgendaItem );
        this.agendaService.addAgendaItem(newAgendaItem);
      }
    }

    this.formDone( true );
  }

  public formDone(done: boolean) {
    if ( done ) {
      this.onAddAgendaDone.emit(false);  // hide modal add screen
    }
  }

  toggleDay( day: number ) {
    this.days[day] = !this.days[day];
  }

  setDuration( val: boolean ) {
    this.useDuration = val;
    if ( !this.useDuration ) {
      this.endTimeHours = this.startTimeHours <= 23 ? this.startTimeHours + 1 : this.startTimeHours ;
      this.endTimeMinutes = this.startTimeMinutes;
      this.duration = null;
      this.calculateStartTime( true );
    } else {
      this.duration = 60;
      this.calculateStartTime( true );
    }
  }

  calculateStartTime( event: any ) {
    this.startTime = this.timeToString( Number(this.startTimeHours), Number(this.startTimeMinutes) );
    this.startTimeInMinutes = Number(this.startTimeHours * 60) + Number(this.startTimeMinutes);
    this.calculateEndTime( true );
  }

  calculateEndTime( event: any ) {
    if ( this.useDuration ) {
      const endtime = Number(this.startTimeInMinutes) + Number(this.duration);

      let hours =  Math.floor(endtime / 60);
      if ( hours > 23 ) {
        hours = hours % 24;
      }
      this.endTimeHours = hours;
      // console.log( `hours2: ${this.endTimeHours}`);

      this.endTimeMinutes = endtime % 60;
      this.endTime = this.timeToString(this.endTimeHours, this.endTimeMinutes);
    } else {
      if ( this.endTimeHours < this.startTimeHours ) {
        this.endTimeHours = 24;
        //this.endTimeHours = this.startTimeHours;
      }
      this.endTime = this.timeToString(this.endTimeHours, this.endTimeMinutes);
    }
  }

  public selectCourt( court: Court ) {
    //console.log(`selected Court: ${JSON.stringify(court)}`);
    this.currentCourt = court;
  }

  useSunset( useIt: boolean ) {
    if ( useIt ) {
      return "";
    } else {
      return "l.dontusesunset";
    }
  }

  timeToString( hours: number, minutes: number ): string {
    let t = "";
    let addLeadingZero1 = false;
    let addLeadingZero2 = false;

    if ( hours > 23  || minutes > 59 ) {
      return 'INVALID';
    }

    if ( hours < 10 ) {
      addLeadingZero1 = true;
    }

    if ( minutes < 10 ) {
      addLeadingZero2 = true;
    }
    t = (addLeadingZero1 ? '0' : '') + hours + ':' + (addLeadingZero2 ? '0': '') + minutes;
    return t;
  }

  numberOfDaysSelected(): number {
    let count = 0;
    for ( let i: number = 0; i < this.days.length; i++ ) {
      if ( this.days[i] ) {
        count++
      }
    }
    return count;
  }

  toggleIsOn() {
    this.isOn = !this.isOn;
    if ( this.isOn ) {
      this.type = 'normal';
    } else {
      this.type = 'off';
    }
  }

}
